import values from "lodash/values";

import { AirIncoterms } from "../../../../../../../api/types/generated-types";

const { Fob, Exw, Fca, ...incoterms } = AirIncoterms;

export const orderedAirIncoterms = [Fob, Exw, Fca, ...values(incoterms)];
